import { createContext } from 'react';

export interface LeaveGuard {
  isBlocking: () => boolean;
  requestLeave: (onProceed: () => void) => boolean;
}

export type RegisterLeaveGuard = (guard: LeaveGuard) => () => void;

export const VerifxLeaveGuardContext = createContext<RegisterLeaveGuard | null>(null);
